import { connect } from 'react-redux'

import { ProtectedRoute } from '../components/ProtectedRoute'
import {
    clearConfigurationRestriction,
    setConfigurationRestriction,
} from '../modules/Common/actions'

const mapStateToProps = ({ common }) => ({
    adp_configurations: common.adp_configurations,
    config_restriction: common.config_restriction,
})

const mapDispatchToProps = {
    setConfigurationRestriction,
    clearConfigurationRestriction,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute)
